module.exports = __webpack_public_path__ + "img/01.bdc9d0d2.jpg";